module.exports = __webpack_public_path__ + "static/media/Ubuntu-Bold.896a6021.ttf";